import React, { useState, useEffect } from "react";
import axios from "axios";
import Modal from "react-modal";
import Swal from "sweetalert2";
import Header from "../../components/Header/header";
import Footer from "../../components/Footer/footer";
import "./TimeEndorsement.css";

Modal.setAppElement("#root");

const RegistrationForm = () => {
  const [formData, setFormData] = useState({
    Sno: "",
    Rname: "",
    VehicleNo: "",
    VehicleType: "",
    UserStatus: "",
    VehicleRfidTag: "",
    RfidNo: "",
    UHFCode: "", 
    Device: "", 
    InOut: "",
    DeviceDT: getCurrentDateTime(),
  });

  const [formErrors, setFormErrors] = useState({
    VehicleNo: false,
    VehicleRfidTag: false,
    Device: false,
    DeviceDT: false,
  });

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [vehicleData, setVehicleData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [isMobile, setIsMobile] = useState(false); 

  
  function getCurrentDateTime() {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  // Automatically set InOut based on Device
  useEffect(() => {
    if (formData.Device) {
      const deviceNum = parseInt(formData.Device);
      const newInOut = (deviceNum === 1 || deviceNum === 3) ? "I" : "O";
      setFormData(prevState => ({
        ...prevState,
        InOut: newInOut
      }));
    }
  }, [formData.Device]);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const barcodeNo = urlParams.get("barcodeNo");
    if (barcodeNo) {
      setFormData((prevState) => ({
        ...prevState,
        VehicleRfidTag: barcodeNo,
        UHFCode: barcodeNo, 
      }));
    }
  }, []);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 400); 
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    return () => {
      window.removeEventListener("resize", checkScreenSize);
    };
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    let newValue = value;

    if (name === "Sno") {
      newValue = value.replace(/\D/g, "");
      if (newValue.length > 7) {
        newValue = newValue.slice(0, 7);
      }
    } else if (name === "Rname") {
      newValue = value.replace(/[^a-zA-Z\s.]/g, "").toUpperCase();
    } else if (name === "VehicleRfidTag") {
      newValue = value.replace(/\D/g, "");
      if (newValue.length > 6) {
        newValue = newValue.slice(0, 6);
      }
      
      setFormData((prevState) => ({
        ...prevState,
        [name]: newValue,
        UHFCode: newValue, 
      }));
      
      fetchVehicleDetails2(newValue);
      return; 
    } else if (name === "VehicleNo") {
      newValue = value.replace(/[^a-zA-Z0-9\s-]/g, "").toUpperCase();
    }

    setFormData((prevState) => ({
      ...prevState,
      [name]: newValue,
    }));

    if (name === "Sno") {
      fetchVehicleDetails(newValue);
    }
  };

  const fetchVehicleDetails = async (Sno) => {
    if (Sno) {
      try {
        const response = await axios.get(
          `https://esystems.cdl.lk/backend/GateSolution/UhfRfid/GetEmpUserDetails?SNo=${Sno}`
        );
        const vehicle = response.data.ResultSet[0];
        if (vehicle) {
          setFormData((prevState) => ({
            ...prevState,
            Rname: vehicle.EmployeeName,
            VehicleNo: vehicle.VehicalNo,
            VehicleType: vehicle.VehicalType,
            UserStatus: vehicle.UserStatus,
            RfidNo: vehicle.RfidNo,
            VehicleRfidTag: vehicle.RfidNo, 
            UHFCode: vehicle.RfidNo,
          }));
        } else {
          setFormData((prevState) => ({
            ...prevState,
            Rname: "",
            VehicleNo: "",
            VehicleType: "",
            UserStatus: "",
            RfidNo: "",
            VehicleRfidTag: "",
            UHFCode: "",
          }));
        }
      } catch (error) {
        console.error("Error fetching vehicle data:", error.message);
      }
    }
  };

  const fetchVehicleDetails2 = async (VehicleRfidTag) => {
    if (VehicleRfidTag) {
      try {
        const response = await axios.get(
          `https://esystems.cdl.lk/backend/GateSolution/UhfRfid/getUserDetails?RFIDCode=${VehicleRfidTag}`
        );
        const vehicle = response.data.ResultSet[0];
        if (vehicle) {
          setFormData((prevState) => ({
            ...prevState,
            Sno: vehicle.SeNo,
            Rname: vehicle.EmployeeName,
            VehicleNo: vehicle.VehicalNo,
            VehicleType: vehicle.VehicalType,
            UserStatus: vehicle.UserStatus,
            UHFCode: VehicleRfidTag,
            RfidNo: VehicleRfidTag,
          }));
        } else {
          setFormData((prevState) => ({
            ...prevState,
            Sno: "",
            Rname: "",
            VehicleNo: "",
            VehicleType: "",
            UserStatus: "",
          }));
        }
      } catch (error) {
        console.error("Error fetching vehicle data:", error.message);
      }
    }
  };

  const handleSubmit = async () => {
    const errors = {};
    let hasErrors = false;

    if (!formData.VehicleNo) {
      errors.VehicleNo = true;
      hasErrors = true;
    }
    if (!formData.VehicleRfidTag) {
      errors.VehicleRfidTag = true;
      hasErrors = true;
    }
    if (!formData.Device) {
      errors.Device = true;
      hasErrors = true;
    }
    if (!formData.DeviceDT) {
      errors.DeviceDT = true;
      hasErrors = true;
    }

    if (hasErrors) {
      setFormErrors(errors);
      return;
    }

    // Ensure InOut is correctly set based on Device before submitting
    const deviceNum = parseInt(formData.Device);
    const inOutValue = (deviceNum === 1 || deviceNum === 3) ? "I" : "O";
    
    const submissionData = {
      ...formData,
      UHFCode: formData.VehicleRfidTag,
      InOut: inOutValue
    };
    
    const uhfCodeWithoutLeadingZeros = formData.VehicleRfidTag.replace(/^0+/, '');
    try {
      const encodedDateTime = encodeURIComponent(submissionData.DeviceDT);
      const timeEndorsementResponse = await fetch(
        `https://esystems.cdl.lk/backend/GateSolution/UhfRfid/TimeEndosment?UHFCode=${uhfCodeWithoutLeadingZeros}&Device=${submissionData.Device}&InOut=${submissionData.InOut}&DeviceDT=${encodedDateTime}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!timeEndorsementResponse.ok) {
        throw new Error("Failed to submit time endorsement data");
      }

      if (timeEndorsementResponse.status === 200) {
        setFormData({
          Sno: "",
          Rname: "",
          VehicleNo: "",
          VehicleType: "",
          VehicleRfidTag: "",
          UHFCode: "",
          Device: "",
          InOut: "",
          DeviceDT: getCurrentDateTime(),
        });

        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Time endorsement submitted successfully!",
        });
      }
    } catch (error) {
      console.error("Error submitting form data:", error.message);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to submit data. Please try again later.",
      });
    }
  };

  const handleDoubleClick = async () => {
    try {
      const response = await axios.get(
        `https://esystems.cdl.lk/backend/GateSolution/UhfRfid/GetVehicleDetails?SNo=`
      );
      setVehicleData(response.data.ResultSet);
      setIsModalOpen(true);
    } catch (error) {
      console.error("Error fetching vehicle data:", error.message);
    }
  };

  const handleRowClick = (vehicle) => {
    setFormData({
      ...formData,
      Sno: vehicle.SeNo,
      Rname: vehicle.EmployeeName,
      VehicleNo: vehicle.VehicalNo,
      VehicleType: vehicle.VehicalType,
      UserStatus: vehicle.UserStatus,
      VehicleRfidTag: vehicle.RfidNo,
      RfidNo: vehicle.RfidNo,
      UHFCode: vehicle.RfidNo,
    });
    setIsModalOpen(false);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const filteredVehicleData = vehicleData.filter((vehicle) =>
    vehicle.SeNo.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div>
      <Header />
      <section className="containerUser">
        <header>Time Endorsement Form</header>
        <div className="form">
          <div className="input-box">
            <input
              type="text"
              name="Sno"
              value={formData.Sno}
              onChange={handleChange}
              onDoubleClick={handleDoubleClick}
              placeholder="Enter Service Number"
            />
          </div>

          <div className="input-box">
            <input
              type="text"
              name="VehicleRfidTag"
              value={formData.VehicleRfidTag}
              onChange={handleChange}
              placeholder="Enter Vehicle RFID Tag"
              required
            />
            {formErrors.VehicleRfidTag && (
              <span className="error-message" style={{color:'red'}}>
                Vehicle RFID Tag is required
              </span>
            )}
          </div>

          <div className="input-box">
            <input
              type="text"
              name="Rname"
              value={formData.Rname}
              onChange={handleChange}
              onDoubleClick={handleDoubleClick}
              onTouchStart={handleDoubleClick}
              placeholder="Enter Employee Name"
            />
          </div>
          
          <div className="input-box">
            <input
              type="text"
              name="VehicleNo"
              value={formData.VehicleNo}
              onChange={handleChange}
              onDoubleClick={handleDoubleClick}
              placeholder="Enter Vehicle No"
              required
            />
            {formErrors.VehicleNo && (
              <span className="error-message" style={{color:'red'}}>Vehicle No is required</span>
            )}
          </div>

          <div className="input-box">
            <select
              name="Device"
              value={formData.Device}
              onChange={handleChange}
              style={{ width: '418px', height: '40px', fontSize: '16px', borderRadius: '5px', color: 'gray', paddingLeft: '10px', borderColor: 'transparent'}}
              required
            >
              <option value="" disabled>
                Select Device
              </option>
              <option value="1" >Gate 01 - IN</option>
              <option value="2" >Gate 01 - OUT</option>
              <option value="3" >Gate 03 - IN</option>
              <option value="4" >Gate 03 - OUT</option>
            </select>
            {formErrors.Device && (
              <span className="error-message" style={{color:'red'}}>Device selection is required</span>
            )}
          </div>

          <div className="input-box">
            <input
              type="datetime-local"
              name="DeviceDT"
              value={formData.DeviceDT.replace(" ", "T")}
              onChange={(e) => {
                
                const dateTimeValue = e.target.value.replace("T", " ");
                setFormData({ ...formData, DeviceDT: dateTimeValue });
              }}
              style={{ width: '418px', height: '40px', fontSize: '16px', borderRadius: '5px', color: 'gray', paddingLeft: '10px', borderColor: 'transparent'}}
              required
            />
            {formErrors.DeviceDT && (
              <span className="error-message">Date and Time is required</span>
            )}
          </div>

          <button type="button" onClick={handleSubmit}>
            Submit
          </button>
        </div>
      </section>
      
      <Modal
        isOpen={isModalOpen}
        onRequestClose={() => setIsModalOpen(false)}
        contentLabel="Vehicle Data"
      >
        <h2>Select Vehicle</h2>
        <input
          type="text"
          placeholder="Search by Service Number"
          value={searchQuery}
          onChange={handleSearchChange}
          className="search-box"
        />
        <table className="gridTbl">
          <thead>
            <tr>
              <th className="thClz">Service No</th>
              <th className="thClz">Vehicle No</th>
              <th className="thClz">Employee Name</th>
              <th className="thClz">Vehicle Type</th>
            </tr>
          </thead>
          <tbody>
            {Array.isArray(filteredVehicleData) &&
            filteredVehicleData.length > 0 ? (
              filteredVehicleData.map((vehicle) => (
                <tr
                  key={vehicle.VehicalNo}
                  onClick={() => handleRowClick(vehicle)}
                >
                  <td className="tdCls">{vehicle.SeNo}</td>
                  <td className="tdCls">{vehicle.VehicalNo}</td>
                  <td className="tdCls">{vehicle.EmployeeName}</td>
                  <td className="tdCls">{vehicle.VehicalType}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4">No data available</td>
              </tr>
            )}
          </tbody>
        </table>

        <button onClick={() => setIsModalOpen(false)}>Close</button>
      </Modal>
      
      <div className="foot">
        <Footer />
      </div>
      
      {isMobile ? (
        <div className="mobileMessage">You are using a mobile device</div>
      ) : (
        <div className="desktopMessage"></div>
      )}
    </div>
  );
};

export default RegistrationForm;